module.exports = __webpack_public_path__ + "img/locator-img.950c49e.svg";